import { OVERLAY_INTERNAL_EVENTS } from '@enums/overlay-internal-events.enum';
import {
  ConfirmationModal,
  Drawer,
  DrawerItem,
  Modal,
  useInternalEvents,
} from '@testsigma/atoms';
import classNames from 'classnames';
import { useCallback, useState } from 'react';
import { useTestDataModalListerner } from './hooks/test-data.hooks';
import { OverlayTypes } from './overlay-types.enum';

const getPortalTarget = (): HTMLElement => {
  const isMobileRecorder =
    window.location.pathname.includes('record/steps') ||
    window.location.pathname.includes('record/stepgroup:true/steps') ||
    window.location.pathname.includes('/ui/recording') ||
    window.location.pathname.includes('/td/debugrun/');

  if (isMobileRecorder) return document.querySelector('#mi-authoring-portal');
  else if (document.querySelector('ts-api-testing'))
    return document.querySelector('ts-api-testing')?.wrapper;
  else return document.body;
};

const DrawerHandler = ({ overlayClassName, zIndex = 2000, drawers = [] }) => {
  const isMobileRecorder =
    window.location.pathname.includes('record/steps') ||
    window.location.pathname.includes('record/stepgroup:true/steps') ||
    window.location.pathname.includes('/ui/recording') ||
    window.location.pathname.includes('/td/debugrun/');

  return (
    <Drawer
      overlayClassName={classNames(overlayClassName, {
        'flex flex-col': isMobileRecorder,
      })}
      zIndex={zIndex}
      portalTarget={getPortalTarget()}
      closeOnOutsideClick={drawers[0]?.closeOnOutsideClick}
      onOutSideClick={drawers[0]?.children?.props?.onOutSideClick}
      closeOnEscape={true}
      onClose={
        drawers[0]?.children?.props?.onDiscard ||
        drawers[0]?.children?.props?.onClose
      }>
      {(drawers || []).map(
        ({ className, width = 490, children, direction = 'right', uuid }) => (
          <DrawerItem
            key={uuid}
            className={classNames(className, {
              'w-full relative': isMobileRecorder,
            })}
            width={isMobileRecorder ? null : width}
            direction={direction}
          >
            {children}
          </DrawerItem>
        ),
      )}
    </Drawer>
  );
};

const ConfiramationHandler = ({
  className,
  zIndex = 2000,
  children,
  title,
  actions = [],
}) => {
  return (
    <ConfirmationModal
      isOpen={true}
      className={className}
      zIndex={zIndex}
      title={title}
      actions={actions}
      portalTarget={getPortalTarget()}>
      {children}
    </ConfirmationModal>
  );
};

const ModalHandler = ({
  overlayClassName,
  className,
  zIndex = 2000,
  children,
}) => {
  return (
    <Modal
      isOpen={true}
      overlayClassName={overlayClassName}
      className={className}
      zIndex={zIndex}
      portalTarget={getPortalTarget()}
      closeOnOutsideClick={true}
      onEscape={true}>
      {children}
    </Modal>
  );
};

const Overlay = ({ type, props, zIndex }) => {
  if (type == OverlayTypes.MODAL) {
    return <ModalHandler zIndex={zIndex} key={props.uuid} {...props} />;
  } else if (type == OverlayTypes.CONFIRMATION) {
    return <ConfiramationHandler zIndex={zIndex} key={props.uuid} {...props} />;
  } else if (type == OverlayTypes.DRAWER) {
    return <DrawerHandler zIndex={zIndex} key={props.uuid} {...props} />;
  }
};

const App = () => {
  const [overlayStack, updateOverlayStack] = useState([]);

  const internalEventHandler = useCallback(
    (eventName, data, publishEvent) => {
      if (eventName == OVERLAY_INTERNAL_EVENTS.OPEN_OVERLAY) {
        updateOverlayStack([...overlayStack, data]);
      } else if (eventName == OVERLAY_INTERNAL_EVENTS.CLOSE_OVERLAY) {
        updateOverlayStack([
          ...overlayStack.filter((item) => item.uuid != data?.uuid),
        ]);
      } else if (eventName == OVERLAY_INTERNAL_EVENTS.UPDATE_OVERLAY) {
        const idx = overlayStack.findIndex((item) => (item.uuid = data.uuid));

        overlayStack[idx] = data;
        updateOverlayStack([...overlayStack]);
      }
    },
    [overlayStack, updateOverlayStack],
  );

  useInternalEvents(
    [
      OVERLAY_INTERNAL_EVENTS.OPEN_OVERLAY,
      OVERLAY_INTERNAL_EVENTS.CLOSE_OVERLAY,
      OVERLAY_INTERNAL_EVENTS.UPDATE_OVERLAY,
    ],
    internalEventHandler,
  );

  useTestDataModalListerner();

  return (
    <div>
      {overlayStack.map((item, idx) => (
        <Overlay
          key={item.props?.uuid}
          type={item.type}
          props={item.props}
          zIndex={2000 + idx * 100}
        />
      ))}
    </div>
  );
};

export default App;
//
